<template>
  <div class="address-editor">
    <div class="address-editor__tip">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <span>{{$t('address.tipRequired')}}</span>
    </div>
    <div class="address-editor__row">
      <div class="address-editor__field">
        <label>{{$t('address.labelLastName')}}<span class="req">*</span></label>
        <input class="form-control" :class="{'is-danger': validateList.indexOf('lastName') > -1}"
               v-model.trim="address.lastName">
      </div>
      <div class="address-editor__field">
        <label>{{$t('address.labelFirstName')}}<span class="req">*</span></label>
        <input class="form-control" :class="{'is-danger': validateList.indexOf('firstName') > -1}"
               v-model.trim="address.firstName">
      </div>
    </div>
    <div class="address-editor__field">
      <label>{{$t('address.labelLine1')}}<span class="req">*</span></label>
      <input class="form-control" :class="{'is-danger': validateList.indexOf('line1') > -1}"
             v-model.trim="address.line1">
    </div>
    <div class="address-editor__field">
      <label>{{$t('address.labelLine2')}}<span class="opt">{{$t('address.labelOptional')}}</span></label>
      <input class="form-control" :class="{'is-danger': validateList.indexOf('line2') > -1}"
             v-model.trim="address.line2">
    </div>
    <div class="address-editor__field">
      <label>{{$t('address.labelCity')}}<span class="req">*</span></label>
      <input class="form-control" :class="{'is-danger': validateList.indexOf('city') > -1}"
             v-model.trim="address.city">
    </div>
    <div class="address-editor__row">
      <div class="address-editor__field">
        <label>{{$t('address.labelState')}}<span class="req">*</span></label>
        <template v-if="showStateInput">
          <input class="form-control"
                 :class="{'is-danger': validateList.indexOf('state') > -1}"
                 v-model.trim="address.state">
        </template>
        <template v-else>
          <select v-model="address.state" :class="{'is-danger': validateList.indexOf('state')> -1}">
            <option :value="item.value" :key="index" v-for="(item, index) in cities">{{item.label}}</option>
          </select>
        </template>
      </div>
      <div class="address-editor__field">
        <label>{{$t('address.labelCountry')}}<span class="req">*</span></label>
        <select v-model="address.countryCode">
          <option :value="item.value" v-for="(item, index) in areas" :key="index">{{item.label}}</option>
        </select>
      </div>
    </div>
    <div class="address-editor__row">
      <div class="address-editor__field">
        <label>{{$t('address.labelPostalCode')}}<span class="req">*</span></label>
        <input type="text" class="form-control" :class="{'is-danger': validateList.indexOf('postalCode')> -1}"
               v-model.trim="address.postalCode">
      </div>
      <div class="address-editor__field">
        <label>{{$t('address.labelPhone')}}<span class="req">*</span></label>
        <input class="form-control" :class="{'is-danger': validateList.indexOf('phone')> -1}"
               v-model.trim="address.phone">
      </div>
    </div>
    <div class="address-editor__field">
      <label>{{$t('address.labelEmail')}}<span class="req">*</span></label>
      <input type="text" class="form-control" :class="{'is-danger': validateList.indexOf('email')> -1}"
             v-model.trim="address.email">
    </div>
  </div>
</template>

<script>
import region from '../../../../static/json/region.json'
import countries from '../../../../static/json/country.json'
import { mapActions, mapGetters } from 'vuex'
import find from 'lodash/find'
import api from '../../../api/'

export default {
  name: '',
  props: {
    ad: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: () => ({
    address: {
      lastName: '',
      firstName: '',
      line1: '',
      line2: '',
      city: '',
      state: '',
      countryCode: '',
      postalCode: '',
      phone: '',
      email: ''
    },
    validateList: [],
    areas: [],
    showStateInput: false
  }),
  computed: {
    ...mapGetters(['locale']),
    country () {
      return region.map(item => {
        return {
          value: item.value,
          label: item.label
        }
      })
    },
    cities () {
      if (!this.areas.length) return []
      const value = this.address.countryCode
      if (value) {
        return find(this.areas, { value }).district
      } else {
        return []
      }
    },
    showTip () {
      const value = this.address.countryCode
      return value === 'TW' || value === 'HK' || value === 'MO'
    }
  },
  watch: {
    'address.countryCode' (val) {
      if (!this.areas.length) return
      this.address.country = find(countries, { alias: val }).label
      if (val !== this.$store.state.locale && val) {
        const cities = find(this.areas, { value: val }).district || []
        if (cities.length) {
          this.address.state = cities[0].value
        } else {
          this.address.state = ''
          this.showStateInput = true
        }
      }
    },
    'address.state' (val) { // 香港，澳门地区的城市默认为区
      if (['HK', 'MO'].includes(this.address.countryCode)) {
        this.address.city = val
      }
    }
  },
  created () {
    this.address = Object.assign({}, this.address, this.ad)
    this.fetchAddress().then(data => {
      if (!this.address.countryCode) {
        this.address.countryCode = this.locale
        const cities = find(data, { value: this.address.countryCode }).district || []
        if (cities.length) {
          this.address.state = cities[0].value
        } else {
          this.showStateInput = true
        }
      } else {
        const cities = find(data, { value: this.address.countryCode }).district || []
        if (!cities.length) {
          this.showStateInput = true
        }
      }
    })
  },
  methods: {
    ...mapActions([
      'setLocale'
    ]),
    fetchAddress () {
      return api.fetchCountries().then(data => {
        data = data.data
        this.areas = data.map(item => {
          item.value = item.countryCode
          return item
        }).filter(item => {
          const codes = countries.map(i => i.alias)
          return codes.includes(item.countryCode)
        })
        return this.areas
      })
    }
  }
}
</script>

<style lang="scss">
.address-editor {
  .address-editor__tip {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    background: lighten($el-color-primary, 32%);
    border-left: 3px solid $el-color-primary;
    padding: 9px 12px;
    border-radius: 6px;
    margin-bottom: 18px;
    font-size: 12.5px;
    color: $el-color-gray-3;
    line-height: 1.55;

    i {
      color: $el-color-primary;
      font-size: 14px;
      margin-top: 2px;
      flex-shrink: 0;
    }
  }

  .address-editor__row {
    display: flex;
    gap: 14px;

    .address-editor__field { flex: 1; min-width: 0; }
  }

  .address-editor__row + .address-editor__row,
  .address-editor__field + .address-editor__field,
  .address-editor__row + .address-editor__field,
  .address-editor__field + .address-editor__row {
    margin-top: 14px;
  }

  .address-editor__field {
    label {
      display: block;
      font-size: 12.5px;
      font-weight: 500;
      color: $el-color-gray-3;
      margin-bottom: 6px;
      letter-spacing: 0.01em;
    }

    .req {
      color: $el-color-primary;
      margin-left: 2px;
    }

    .opt {
      color: $el-color-gray-4;
      font-weight: 400;
      margin-left: 4px;
      font-size: 11.5px;
    }
  }

  .form-control,
  select {
    width: 100%;
    height: 40px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 0 12px;
    font-family: inherit;
    font-size: 14px;
    color: #1a1a2e;
    background-color: #fff;
    transition: border-color .2s, box-shadow .2s;
    outline: none;
    font-weight: 500;
    box-sizing: border-box;

    &:hover { border-color: #d4d4d4; }

    &:focus {
      border-color: $el-color-primary;
      box-shadow: 0 0 0 3px rgba(245, 99, 104, .15);
    }

    &::placeholder { color: #cfd2d8; }

    &.is-danger {
      border-color: $el-color-danger;
    }
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 29 14" width="29"><path fill="%23b3b3b3" d="M9.37727 3.625l5.08154 6.93523L19.54036 3.625"/></svg>');
    background-repeat: no-repeat;
    background-position: right 10px center;
    padding-right: 32px;

    &:disabled { opacity: 0.5; }

    &:focus {
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" viewBox="0 0 29 14" width="29"><path fill="%23F56368" d="M9.37727 3.625l5.08154 6.93523L19.54036 3.625"/></svg>');
    }
  }
}
</style>
